import { store } from '../store/store';
import type { FontSize } from '../schema/FontSize';

/**
 * Returns font scale indicating the value of currentFontSize property in the store
 */
export const getFontSize = (): FontSize => store.fontSize;
